import axios from "axios";
// import { ElNotification } from "element-plus";
import { Notification } from "element-ui";
import store from "../store";
import Router from "@/router/client";
// 创建axios的实例
const url = new URL(window.location.href);
let baseURL = "";
if (url.hostname === "192.168.89.251") {
  baseURL = "http://192.168.89.250:8888";
} else if (url.hostname === "192.178.0.89") {
  baseURL = "http://192.178.0.89:8888";
} else {
  baseURL = "https://api.ontuotu.com";
}
const service = axios.create({
  baseURL,
  timeout: 60000, // 超时时间
});
const SILENT_ERROR_FORM_UUID = "9beb839e9fd511eeb2180242321230b4";
function shouldSuppressErrorNotification(config) {
  const params = config && config.params;
  return Boolean(
    config &&
      (config.suppressErrorNotification ||
        (params && params.form_head_uuid === SILENT_ERROR_FORM_UUID))
  );
}
function reportSuppressedError(message, error) {
  console.error("[API error]", message, error || "");
}
function isRichText(str) {
  const htmlTagPattern = /<\/?[a-z][\s\S]*>/i;
  return htmlTagPattern.test(str);
}
function isFirstCharacter(str) {
  var firstChar = str.substr(0, 1);
  return firstChar === "/";
}
function initUrl(objectFile) {
  for (const key in objectFile) {
    const value = objectFile[key];

    if (Array.isArray(value) && value.length > 0) {
      objectFile[key] = value.map((item) => {
        if (item && item.url) {
          item.url = `${baseURL}${isFirstCharacter(item.url) ? "" : "/"}${
            item.url
          }`;
        }
        return item;
      });
    } else if (isRichText(value)) {
      objectFile[key] = value.replace(
        /(<img\s+[^>]*src=")([^"]+)(")/g,
        (match, p1, p2, p3) => {
          const newSrc = `${baseURL}/${p2.split("/").pop()}`;
          return `${p1}${newSrc}${p3}`;
        }
      );
    }
  }
}
const reduiceLogin = () => {
  sessionStorage.clear();
  localStorage.clear();
  Router.push("/login");
};

service.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("clientToken");
    const temporarilyToken = store.state.temporarilyToken;
    config.headers.Authorization = "Bearer " + (token || temporarilyToken);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// 响应拦截
service.interceptors.response.use(
  (response) => {
    // 请求成功
    const res = response.data;
    if (res instanceof Blob) {
      return res;
    } else if (res.status !== "success") {
      if (shouldSuppressErrorNotification(response.config)) {
        reportSuppressedError(res.errMsg || res.message || "API request failed");
      } else {
        Notification.error({
          title: "请求错误",
          message: res.errMsg,
          duration: 0,
        });
      }
      return Promise.reject(new Error(res.message || "Error"));
    } else {
      if (["192.168.89.251", "192.178.0.89"].includes(url.hostname)) {
        if (res.result && Array.isArray(res.result)) {
          res.result.map((el) => {
            initUrl(el);
            return el;
          });
        } else if (typeof res.result === "object") {
          initUrl(res.result);
        }
      }
      return res;
    }
  },
  (err) => {
    let errMsg = "";
    const status = err.response && err.response.status;
    if (status) {
      switch (status) {
        case 400:
          errMsg = err.response.data.err_msg;
          break;
        case 401:
          errMsg = "登录状态失效，请重新登录";
          reduiceLogin();
          break;
        case 403:
          errMsg = err.response.data.err_msg;
          break;
        case 408:
          errMsg = "请求超时";
          break;
        case 500:
          errMsg = "服务器内部错误";
          break;
        case 501:
          errMsg = "服务未实现";
          break;
        case 502:
          errMsg = "网关错误";
          break;
        case 503:
          errMsg = "服务不可用";
          break;
        case 504:
          errMsg = "网关超时";
          break;
        case 505:
          errMsg = "HTTP版本不受支持";
          break;
        default:
          errMsg = err.response.data.err_msg;
          break;
      }
      if (shouldSuppressErrorNotification(err.config)) {
        reportSuppressedError(errMsg, err);
      } else {
        Notification.error({
          title: "请求错误",
          message: errMsg,
        });
      }
    } else {
      errMsg = err;
    }
    store.commit("hideLoading");
    return Promise.reject(errMsg);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/util/request.js